import { Box } from '@mui/material';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { WsTypography } from 'wisestep-base';

import { StandardHeightsByRows } from '../../../';
import { MappingsWidget } from '../../../DerivedCharts/helper';
import { CustomNoRowsOverlay } from '../../../helper/showCustomizeNoDataTextDataGrid';
import usePostgreMappingWidgetData from '../../../hooks/usePostgreMappingWidgetData';
import { IPostgreMappingsWidgetProp } from '../types';
import { getColumnsForMappings } from '../utils/mappingsPostgresHelper';

const MappingsTablePostgre = ({
  query,
  title,
  widgetName,
}: Required<IPostgreMappingsWidgetProp>) => {
  const { widgetData } = usePostgreMappingWidgetData(query);
  const rowNum = [
    MappingsWidget.CLIENTS,
    MappingsWidget.RECRUITER_NAME,
    MappingsWidget.ACCOUNT_MANAGER,
    MappingsWidget.JOB_TYPE,
    MappingsWidget.SOURCE,
    MappingsWidget.DOWNLOAD_SOURCE,
    MappingsWidget.PROFILE_DOWNLOAD_SOURCE,
    MappingsWidget.RECRUITER_TEAM,
    MappingsWidget.JOB_TITLE,
    MappingsWidget.RECRUITER_TEAM_JOBTYPE,
    MappingsWidget.RECRUITER_DOWNLOAD_SOURCE,
    MappingsWidget.RECRUITER_SOURCE,
    MappingsWidget.RECRUITER_DOWNLOAD_SOURCE_UPLOADED,
    MappingsWidget.RECRUITER_SOURCE_UPLOADED,
    MappingsWidget.TABLE_TIME_TO_SERVICE,
  ].includes(widgetName)
    ? 5
    : [
        MappingsWidget.TABLE_JOB_TITLE,
        MappingsWidget.TABLE_JOB_SOURCE,
        MappingsWidget.TABLE_JOB_BOARD,
      ].includes(widgetName)
    ? 10
    : 3;
  const [tableData, columns] = getColumnsForMappings(widgetName, widgetData);
  return (
    <Box>
      <WsTypography bold={true}>{title}</WsTypography>
      <Box mt={1.5} sx={{ height: StandardHeightsByRows[rowNum] }}>
        <DataGrid
          columns={columns}
          rows={tableData}
          components={{ Toolbar: GridToolbar, NoRowsOverlay: CustomNoRowsOverlay }}
          pageSize={rowNum}
          rowsPerPageOptions={[rowNum]}
          initialState={{
            sorting: {
              sortModel: [{ field: 'count', sort: 'desc' }],
            },
          }}
          sx={{ overflowY: 'hidden' }}
        />
      </Box>
    </Box>
  );
};

export default MappingsTablePostgre;
